import axios from "axios";

// ==========================================================
// API Base URL
// ==========================================================

const API_URL = "/api";

// ==========================================================
// Analyze Sentiment
// ==========================================================

export const analyzeSentiment = async (text) => {

  try {

    const response = await axios.post(

      `${API_URL}/predict`,

      {
        text,
      }
    );

    return response.data;

  } catch (error) {

    console.error(
      "AI API Error:",
      error
    );

    return {

      sentiment: "error",

      confidence: 0,

      scores: {

        positif: 0,

        negatif: 0,
      },
    };
  }
};

// ==========================================================
// Get Reviews
// ==========================================================

export const getReviews = async () => {

  try {

    const response = await axios.get(

      `${API_URL}/reviews`
    );

    return response.data;

  } catch (error) {

    console.error(
      "Get Reviews Error:",
      error
    );

    return [];
  }
};

// ==========================================================
// Submit Review
// ==========================================================

export const submitReview = async (reviewData) => {

  try {

    const response = await axios.post(

      `${API_URL}/reviews`,

      {

        movie_id: reviewData.movie_id,

        username: reviewData.username,

        rating: reviewData.rating,

        comment: reviewData.comment,
      }
    );

    return response.data;

  } catch (error) {

    console.error(
      "Submit Review Error:",
      error
    );

    throw error;
  }
};

